export default "__VITE_ASSET__YghOWfMw__"